import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { TokenStorageService } from '../services/token-storage-service/token-storage.service';
import { ApiService } from '../services/api-service/api.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private tokenStorageService: TokenStorageService,
    private apiService: ApiService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let errorMessage = err.error.globalErrors[0].message
          ? err.error.globalErrors[0].message
          : '';
        if (err.status === 401 && errorMessage === 'jwt expired') {
          this.apiService.refreshToken().subscribe(
            (data: any) => {
              this.tokenStorageService.saveToken(data.token);
              this.tokenStorageService.saveRefreshToken(data.refreshToken);
              this.tokenStorageService.saveUser(data.user);
              window.location.reload();
            },
            () => {
              // Auto logout if 401 response returned from api
              this.tokenStorageService.signOut();
            }
          );
        } else if (err.status === 401) {
          this.tokenStorageService.signOut();
        }

        let errMessage: any;
        if (err.error.globalErrors && err.error.globalErrors.length) {
          errMessage = err.error.globalErrors[0].message;
        }
        if (err.error.fieldErrors && err.error.fieldErrors.length) {
          errMessage = err.error.fieldErrors[0].message;
        }
        const error =
          errMessage || err.error.message || err.message || err.statusText;
        return throwError(error);
      })
    );
  }
}

export const errorInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
